const url = `/user-service/api/external`;

export const operatorsContext = {
  operators: `${url}/operators`,
  operatorById: `${url}/operators/{id}`,
  updateOperatorRoles: `${url}/operators/{id}/roles`,
  updateOperator: `${url}/operators/{id}/details`,
};
